export const BASE_URL = "https://backend.lyricsacademy.in/admin";
//export const BASE_URL = "http://localhost:5000/admin";
export const S3_CDN = "https://d9kj6xjcfol40.cloudfront.net";
